module.exports = __webpack_public_path__ + "static/banner_myinfo_mobile@2x-82e55b0c90c27298bcfef159915d7728.png";